import { ScoutingPlace } from "@/models";
import { Component, Vue } from "vue-property-decorator";
import { BASE_API_URL } from "../../utils/Constants";

const GET_SCOUTING = "get_current_scouting";
const SAVE_SCOUTING = "save_scouting";
const SAVE_SCOUTING_PLACES = "create_massive_scouting_places";
const SAVE_SCOUTING_PLACE = "create_scouting_place";
const DESTROY_SCOUTING_PLACE = "destroy_scouting_place";
const RESET_SCOUTING_PLACE = "reset_scouting_place";
const GET_SCOUTING_PLACES = "get_scouting_places";

const GET_SCOUTING_AREAS = "get_scouting_areas";
const DESTROY_SCOUTING_AREA = "destroy_scouting_area";

@Component
export default class ScoutingsMixin extends Vue {
  readonly path = BASE_API_URL + "current_user/scouting";

  getCurrentScouting() {
    return this.$httpGet(this.path, GET_SCOUTING);
  }

  updateScouting(payload: any) {
    return this.$httpPut(this.path, SAVE_SCOUTING, payload);
  }

  createScoutingPlaces(payload: any) {
    return this.$httpPost(
      this.path + "/scouting_places/massive",
      SAVE_SCOUTING_PLACES,
      payload,
    );
  }

  updateScoutingPlace(payload: any) {
    return this.$httpPost(
      this.path + "/scouting_places/" + payload.id,
      SAVE_SCOUTING_PLACE,
      payload,
    );
  }

  createScoutingPlace(payload: any) {
    return this.$httpPost(
      this.path + "/scouting_places",
      SAVE_SCOUTING_PLACE,
      payload,
    );
  }

  getScoutingPlaces() {
    return this.$httpGet(this.path + "/scouting_places", GET_SCOUTING_PLACES);
  }

  resetScouting() {
    return this.$httpPost(this.path + "/reset", RESET_SCOUTING_PLACE, {});
  }

  destroyScoutingPlace(id: string) {
    return this.$httpDelete(
      this.path + "/scouting_places/" + id,
      DESTROY_SCOUTING_PLACE,
      { id },
    );
  }

  getScoutingAreas() {
    return this.$httpGet(this.path + "/scouting_areas", GET_SCOUTING_AREAS);
  }

  destroyScoutingArea(id: string) {
    return this.$httpDelete(
      this.path + "/scouting_areas/" + id,
      DESTROY_SCOUTING_AREA,
      { id },
    );
  }

  //  updateScuotingIsocron(data: any) {
  //   return this.$httpPut(this.path+'/scouting_places/'+id, SAVE_SCOUTING_PLACES, {id});
  //  }
}
